import { isFunction } from "__barrel_optimize__?names=isFunction!=!lodash-es";
import { RegisterApi } from "@/service/register";
import { useUserCreate } from "@/store/User";
/**
 * [查询用户信息]
 */
export const getUserInfoByInit = function () {
  let resetSocket = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false,
    cb = arguments.length > 1 ? arguments[1] : void 0;
  RegisterApi.getUserInfoV().then(res => {
    isFunction(cb) && cb(res);
    if (res.code === 0) {
      const resData = res === null || res === void 0 ? void 0 : res.data;
      // 更新用户信息
      useUserCreate.getState().dispatch({
        type: "updateUserInfo",
        payload: resData
      });
    }
  });
};